import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import HandshakeIcon from '@mui/icons-material/Handshake';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const SynergySection = ({ activeTab }) => {
  const isBusiness = activeTab === 0;

  return (
    <Box sx={{ background: '#13111C', py: 10, color: '#fff' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={8}>
          <Typography variant="caption" sx={{ color: '#00A86B', fontWeight: 'bold', letterSpacing: 1 }}>
            COLABORACIÓN SINERGÉTICA
          </Typography>
          <Typography variant="h3" fontWeight={800} mt={2} mb={3}>
            Donde {isBusiness ? 'tu Empresa encuentra el Talento' : 'tu Talento encuentra a la Empresa'}
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.7)', maxWidth: 800, mx: 'auto' }}>
            A diferencia de otras herramientas, Hitpoly no es solo un software; es una economía. La interacción entre las empresas que buscan escalar y los profesionales capacitados crea un círculo virtuoso de crecimiento continuo.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <Paper elevation={0} sx={{ p: 4, background: 'rgba(255,255,255,0.02)', borderRadius: '20px', height: '100%', textAlign: 'center', border: '1px solid rgba(255,255,255,0.05)' }}>
                <Diversity3Icon sx={{ fontSize: 50, color: '#6C4DE2', mb: 2 }} />
                <Typography variant="h5" fontWeight="bold" mb={2}>Comunidad B2B Activa</Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>
                  {isBusiness 
                    ? 'Interactúa con otras agencias y proveedores de servicios. Comparte estrategias, solicita ayuda técnica y encuentra colaboradores para proyectos específicos directamente en el muro.'
                    : 'Aprende de casos de éxito reales. Participa en foros técnicos, resuelve dudas de empresas y demuestra tu valor en la comunidad para ganar visibilidad.'}
                </Typography>
              </Paper>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={4}>
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
              <Paper elevation={0} sx={{ p: 4, background: 'rgba(255,255,255,0.02)', borderRadius: '20px', height: '100%', textAlign: 'center', border: '1px solid rgba(255,255,255,0.05)' }}>
                <HandshakeIcon sx={{ fontSize: 50, color: '#00A86B', mb: 2 }} />
                <Typography variant="h5" fontWeight="bold" mb={2}>Contratos Seguros</Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>
                  {isBusiness 
                    ? 'Contrata desde la Bolsa de Profesionales sabiendo que el talento ha sido verificado. Gestiona los pagos y acuerdos directamente a través de Hitpoly sin comisiones abusivas.'
                    : 'Trabaja con empresas serias. Hitpoly asegura que las oportunidades publicadas sean legítimas. Cierra contratos directamente con CEOs y directores de agencias.'}
                </Typography>
              </Paper>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={4}>
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}>
              <Paper elevation={0} sx={{ p: 4, background: 'rgba(255,255,255,0.02)', borderRadius: '20px', height: '100%', textAlign: 'center', border: '1px solid rgba(255,255,255,0.05)' }}>
                <TrendingUpIcon sx={{ fontSize: 50, color: '#F21C63', mb: 2 }} />
                <Typography variant="h5" fontWeight="bold" mb={2}>Crecimiento Mutuo</Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>
                  {isBusiness 
                    ? 'A medida que tu empresa crece gracias a los leads y el CRM, puedes inyectar ese capital para contratar más talento, expandiendo tus operaciones de forma exponencial.'
                    : 'A medida que completas cursos en la Academia y sumas experiencia con clientes del ecosistema, tu tarifa y autoridad aumentan, atrayendo a las empresas más grandes de Hitpoly.'}
                </Typography>
              </Paper>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default SynergySection;
